module.exports = __webpack_public_path__ + "img/logo.ecleaning.e870007b.svg";